class CollectionRangeShowcase extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.collection-range__list');
    this.links = this.querySelectorAll('.collection-range__link');
    this.images = this.querySelectorAll('[data-range-image]');
    this.mobileButton = this.querySelector('.collection-range__mobile-button');
    this.mobileBreakpoint = window.matchMedia('(max-width: 989px)');

    if (!this.list || this.links.length < 2) return;

    this.defaultId = this.links[0].dataset.rangeTarget;
    this.setActive(this.defaultId);

    this.links.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (!this.mobileBreakpoint.matches) this.setActive(link.dataset.rangeTarget);
      });
      link.addEventListener('focus', () => this.setActive(link.dataset.rangeTarget));
      link.addEventListener('click', (event) => {
        // On mobile, tapping a range name - any number of times - only swaps
        // the preview image and keeps the "Discover now" button's target in
        // sync. It never navigates by itself; only "Discover now" does.
        if (this.mobileBreakpoint.matches) {
          event.preventDefault();
          this.setActive(link.dataset.rangeTarget);
        }
      });
    });

    // The hover-out reset only makes sense for desktop mouse interaction -
    // guarding it for mobile is what previously let the "Discover now"
    // button's target silently fall back to the first range (Keywest)
    // between a tap on a range name and a tap on the button.
    this.list.addEventListener('mouseleave', () => {
      if (!this.mobileBreakpoint.matches) this.setActive(this.defaultId);
    });
  }

  setActive(id) {
    this.links.forEach((link) => link.classList.toggle('active', link.dataset.rangeTarget === id));
    this.images.forEach((image) => image.classList.toggle('active', image.dataset.rangeImage === id));

    if (this.mobileButton) {
      const activeLink = Array.from(this.links).find((link) => link.dataset.rangeTarget === id);
      if (activeLink && activeLink.dataset.rangeUrl) {
        this.mobileButton.setAttribute('href', activeLink.dataset.rangeUrl);
      }
    }
  }
}

customElements.define('collection-range-showcase', CollectionRangeShowcase);
